<template>
  <v-card class="mt-3 rounded-card">
    <v-card-title class="font-weight-bold">
      Mensagens personalizadas
    </v-card-title>
    <v-card-text>
      <px-mensagens-personalizadas-list
        :messages="aprovacao.mensagensPersonalizadas"/>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
};
</script>
